import useSWR from "swr";
import { URL_API } from "../../../@richbeauty/services/endpoint";
import jwtAxios from "../../../@richbeauty/services/auth/jwt-auth/jwt-api";

const getAllProducts = async (extraParams) => {
  const { data } = await jwtAxios.get(URL_API.CMS_PRODUCTS.GET_PRODUCTS, {
    params: {
      page: 1,
      take: 1000,
      ...extraParams,
    },
  });
  return data;
};
const useGetAllProducts = (params) => {
  return useSWR(
    {
      url: URL_API.CMS_PRODUCTS.GET_PRODUCTS,
      tags: ["#products"],
      ...(params ? { params } : {}),
    },
    () => getAllProducts(params)
  );
};
export default useGetAllProducts;
